
import { defineComponent } from "@vue/runtime-core";
import * as TaskManager from "@/firebase/TaskManager";
import TemperatureResultRow from "@/components/tasks/table/TemperatureResultRow.vue";
import Task from "@/model/Task";
import Store from "@/model/Store";
import TemperatureResult from "@/model/TaskResults/TemperatureResult";
import * as Lang from "@/i18n/lang";
import TaskStatus from "../TaskStatus.vue";
import TaskWithResult from "@/pinia/tasks/TaskWithResult";
import * as DateUtils from "@/utils/DateUtils";

export default defineComponent({
  props: {
    taskWrapper: {
      type: TaskWithResult,
      required: true,
    },
    store: {
      type: Store,
    },
  },

  expose: ["expendable"],

  methods: {},

  async mounted() {
    this.notFilledCount = this.taskWrapper.results.filter(
      (x) => x.temperature == null
    ).length;

    this.invalidRangeCount = this.taskWrapper.results.filter(
      (x) => !x.isTemperatureRangeValid()
    ).length;
  },

  data() {
    return {
      TaskManager: TaskManager,
      Lang: Lang,
      invalidRangeCount: 0,
      notFilledCount: 0,
      DateUtils: DateUtils,
      results: [] as TemperatureResult[],
    };
  },
  components: {
    TemperatureResultRow,
    TaskStatus,
  },
});
